function Transcript(props) {
    return (<div className='my-3' dangerouslySetInnerHTML={{__html: props.html}} />);
}

export default Transcript;